import React, { useMemo } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import useScopePermissions from "hooks/useScopePermissions";
import { Icon } from "components/common";
import { Row } from "common/components/layout-styles";
const TitleText = styled.div`
  text-wrap: balance;
  overflow-wrap: anywhere;
  word-break: break-word;
  text-align: left;
  text-decoration: ${({ $isDisabled }) => $isDisabled ? "line-through" : "initial"};
  overflow: hidden;
`;
const StyledIcon = styled(Icon)`
  color: ${({ theme }) => theme.colors.text.secondary};
`;
function SearchFilterTitle({ filter, disabled = false, children = void 0 }) {
  const { scopePermissions } = useScopePermissions(filter);
  const showLockIcon = useMemo(() => !(scopePermissions == null ? void 0 : scopePermissions.is_mutable), [scopePermissions == null ? void 0 : scopePermissions.is_mutable]);
  const { t } = useTranslation("enterprise_search");
  return /* @__PURE__ */ React.createElement(Row, { $gap: "xs", $align: "center", style: { overflow: "hidden", textOverflow: "ellipsis" } }, showLockIcon && /* @__PURE__ */ React.createElement(StyledIcon, { name: "lock", type: "solid", title: t("search_filter_title.read_only") }), /* @__PURE__ */ React.createElement(TitleText, { $isDisabled: disabled }, children));
}
export default SearchFilterTitle;
